export default "__VITE_ASSET__BlvEVkph__"